// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-p_fG","advertDetailParameterList__header":"c-p_fH","advertDetailParameterList__list":"c-p_fJ"};